class CustomTabs extends HTMLElement {
  connectedCallback() {
    const tabs = this.querySelectorAll('.tab-label');
    const contents = this.querySelectorAll('.tab-content');

    if (!this.querySelector('.tab-label.active')) {
      tabs[0].classList.add('active');
      contents[0].setAttribute('active', '');
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        this.selectTab(tabs, contents, index);
      });
    });
  }

  selectTab(tabs, contents, index) {
    tabs.forEach((tab, i) => {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
    });
    tabs[index].classList.add('active');
    tabs[index].setAttribute('aria-selected', 'true');

    contents.forEach((content, i) => {
      content.removeAttribute('active');
    });
    contents[index].setAttribute('active', '');
  }
}

customElements.define('custom-tabs', CustomTabs);
